import React from "react";

// Catálogo de tipos de sección de almacén, con descripción para el tooltip de ayuda.
export const TIPOS_SECCION = [
  { value: "almacenamiento", label: "Almacenamiento", descripcion: "Zona general para guardar mercancía en racks a la espera de ser surtida." },
  { value: "picking", label: "Picking", descripcion: "Zona de surtido: de aquí se recolecta la mercancía para armar los pedidos." },
  { value: "recepcion", label: "Recepción", descripcion: "Entrada de mercancía: donde llega, se revisa y se acomoda al almacén." },
  { value: "embarque", label: "Embarque", descripcion: "Salida de mercancía: preparación y carga de los envíos a clientes." },
  { value: "cuarentena", label: "Cuarentena", descripcion: "Mercancía retenida en espera de revisión de calidad o liberación." },
  { value: "devoluciones", label: "Devoluciones", descripcion: "Producto devuelto por clientes, pendiente de revisar y reintegrar." },
  { value: "produccion", label: "Producción", descripcion: "Área ligada a manufactura/ensamble (consumo o salida de producto)." },
  { value: "restringida", label: "Restringida", descripcion: "Acceso limitado: puede requerir permiso o equipo especial para entrar." },
  { value: "otro", label: "Otro", descripcion: "Cualquier otro uso que no encaje en las categorías anteriores." },
];

export const descripcionTipo = (valor) => TIPOS_SECCION.find((t) => t.value === valor)?.descripcion || "";

// Tooltip con la leyenda de TODOS los tipos de sección, para que el usuario sepa qué significa cada uno.
export const AyudaTiposSeccion = (
  <div style={{ maxWidth: 260 }}>
    {TIPOS_SECCION.map((t) => (
      <div key={t.value} style={{ marginBottom: 4 }}>
        <strong>{t.label}:</strong> {t.descripcion}
      </div>
    ))}
  </div>
);
